var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-theme",
    { attrs: { "md-name": "default" } },
    [
      _c(
        "md-card",
        { attrs: { id: "card-item" } },
        [
          _c(
            "md-card-media",
            [
              _vm.lightUpVideo
                ? _c("video", {
                    staticClass: "video-class",
                    attrs: {
                      src: _vm.getVideoSource(_vm.item),
                      type: _vm.getVideoType(_vm.item),
                      autoplay: "autoplay",
                      controls: "controls"
                    }
                  })
                : _c(
                    "md-layout",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "overlay-play md-primary md-raised play",
                          attrs: {
                            id: "btn-play-item-card",
                            "md-theme": "blue"
                          },
                          on: {
                            click: function($event) {
                              _vm.lightUpVideo = !_vm.lightUpVideo
                            }
                          }
                        },
                        [
                          _c("md-icon", {
                            attrs: { "md-iconset": "fa fa-play-circle" }
                          }),
                          _c("span", [_vm._v("PLAY")])
                        ],
                        1
                      ),
                      _c("img", {
                        staticClass: "card__img",
                        attrs: {
                          src: _vm.getVideoPoster(_vm.item),
                          alt: _vm.item.name,
                          width: 250,
                          height: 200
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _c("md-card-header", [
            _c("div", { staticClass: "card__header" }, [
              _vm._v(_vm._s(_vm.mediumTitle(_vm.item)))
            ]),
            _c("div", { staticClass: "md-subtitle" }, [
              _vm._v(_vm._s(_vm.item.credit || _vm.item.account.name))
            ]),
            _c("div", { staticClass: "md-subhead" }, [
              _vm._v(_vm._s(_vm.formattedDate(_vm.item.lastUpdated)))
            ]),
            _c("div", { staticClass: "md-subhead" }, [
              _vm._v(_vm._s(_vm.secondsToHms(_vm.item.duration)))
            ])
          ]),
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                [
                  _c("p", { staticClass: "priceStyle" }, [
                    _vm._v(_vm._s(this.pricing))
                  ]),
                  _c("span", { staticStyle: { flex: "1" } }),
                  _c(
                    "transition",
                    {
                      attrs: {
                        name: "bounce",
                        "enter-active-class": "animated bounceIn",
                        "leave-active-class": "animated bounceOut",
                        mode: "out-in"
                      }
                    },
                    [
                      _vm.addingOrRemovingFromPlaylist
                        ? _c("md-spinner", {
                            staticClass: "md-warn card-action-spinner",
                            attrs: {
                              "md-indeterminate": "md-indeterminate",
                              "md-size": 25
                            }
                          })
                        : _vm._e(),
                      !_vm.itemInPlaylist && !_vm.addingOrRemovingFromPlaylist
                        ? _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button md-accent",
                              attrs: { id: "btn-add-item-card" },
                              on: { click: _vm.addPlaylistItem }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-plus-circle" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.itemInPlaylist && !_vm.addingOrRemovingFromPlaylist
                        ? _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button md-warn",
                              attrs: { id: "btn-remove-item-card" },
                              on: { click: _vm.removePlaylistItem }
                            },
                            [
                              _c("md-icon", {
                                attrs: { "md-iconset": "fa fa-trash-alt" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-icon-button",
                      attrs: { "md-expand-trigger": "md-expand-trigger" }
                    },
                    [
                      _c("md-icon", {
                        attrs: { "md-iconset": "fa fa-chevron-down" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("md-card-content", [
                _c("span", { staticClass: "md-subheading" }, [
                  _vm._v(_vm._s(_vm.networkName(_vm.item)))
                ]),
                _c("div", {
                  staticClass: "card__text",
                  domProps: { innerHTML: _vm._s(_vm.item.description) }
                })
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5394e36", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5394e36","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/MediaItem.vue
// module id = 654
// module chunks = 0